import { ActionReducer } from '@ngrx/store';

import { Actions, ActionTypes } from './cabinet-positions.actions';
import { CabinetPositionsInterface as CabinetPositions } from './cabinet-positions.models';
import { tassign } from '../../tools';

/**
 * Please do not modify the store directly. Always use reducers.
 */

export const initialCabinetPositionsState: CabinetPositions = {
	items: [],
	isLoading: false
};

/**
 * Reduce the store.
 * @param {CabinetPositions} state - the current state
 * @return {CabinetPositions} The new state
 */
export const cabinetPositions: ActionReducer<any, Actions> = (state: CabinetPositions = initialCabinetPositionsState, action: Actions): CabinetPositions => {
	switch (action.type) {

		case ActionTypes.LOAD_CABINET_POSITIONS:
			return action.payload;

		case ActionTypes.RESET_STATE:
			return initialCabinetPositionsState;

		case ActionTypes.SET_IS_LOADING:
			return tassign(state, {
				isLoading: action.payload
			});
	}
	return state;
};